import React from 'react'

const FacebookIcon: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      {/* Blue circle background */}
      <circle cx="12" cy="12" r="12" fill="#1877F2" />

      {/* White "f" */}
      <path
        d="M15.5 8.5H13.8C13.1 8.5 13 8.8 13 9.3v1.7h2.4l-.3 2.6H13v6h-2.6v-6H8.5v-2.6h1.9V9.1c0-2 1.1-3.1 3.4-3.1h1.7v2.5z"
        fill="white"
      />
    </svg>
  )
}

export default FacebookIcon
